import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import {
    FaGamepad,
    FaCrown,
    FaShieldAlt,
    FaShoppingBag,
    FaBoxOpen,
    FaBars,
    FaTimes,
} from "react-icons/fa";
import { IStore } from "@/redux/defaultStore";
import { toggleSidebar } from "@/redux/meta/metaActions";
import "./DevourPlayMobileNav.scss";

interface MobileNavItem {
    id: string;
    label: string;
    icon: React.ComponentType<any>;
    path: string;
}

const MOBILE_NAV_ITEMS: MobileNavItem[] = [
    {
        id: "play",
        label: "Play",
        icon: FaGamepad,
        path: "/play",
    },
    {
        id: "govip",
        label: "GoVIP",
        icon: FaCrown,
        path: "/go-vip-dashboard",
    },
    {
        id: "guilds",
        label: "Guilds",
        icon: FaShieldAlt,
        path: "/guilds",
    },
    {
        id: "lootshop",
        label: "LootShop",
        icon: FaShoppingBag,
        path: "/lootshop",
    },
    {
        id: "lootboxes",
        label: "LootBoxes",
        icon: FaBoxOpen,
        path: "/devourlootbox",
    },
];

export default function DevourPlayMobileNav() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const sidebarOpen = useSelector((store: IStore) => store.metaStore.sidebarOpen);
    const isModalActive = useSelector((store: IStore) => store.metaStore.activeModals);
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    const handleNavClick = (item: MobileNavItem) => {
    // Close sidebar if open
        if (sidebarOpen) {
            dispatch(toggleSidebar(false));
        }

        // Special handling for favorites - requires auth
        if (item.id === "favorites" && !fullToken) {
            return;
        }

        navigate(item.path);
    };

    const handleMenuToggle = () => {
        dispatch(toggleSidebar(!sidebarOpen));
    };

    const isActiveRoute = (path: string) => {
        return location.pathname === path || location.pathname.startsWith(`${path}/`);
    };

    // Don't show mobile nav if modal is active
    if (isModalActive !== 0) {
        return null;
    }

    return (
        <div className="devourplay-mobile-nav">
            <div className="devourplay-mobile-nav_content">
                {MOBILE_NAV_ITEMS.map((item) =>
                    <button
                        key={item.id}
                        className={classNames("devourplay-mobile-nav_item", {
                            "devourplay-mobile-nav_item_active": isActiveRoute(item.path) && !sidebarOpen,
                            "devourplay-mobile-nav_item_disabled": item.id === "favorites" && !fullToken,
                        })}
                        onClick={() => handleNavClick(item)}
                        disabled={item.id === "favorites" && !fullToken}
                    >
                        <item.icon className="devourplay-mobile-nav_icon" />
                        {/* Icons only - no labels */}
                    </button>)}

                <button
                    className={classNames("devourplay-mobile-nav_item devourplay-mobile-nav_menu", {
                        "devourplay-mobile-nav_item_active": sidebarOpen,
                    })}
                    onClick={handleMenuToggle}
                >
                    {sidebarOpen
                        ? <FaTimes className="devourplay-mobile-nav_icon" />
                        : <FaBars className="devourplay-mobile-nav_icon" />
                    }
                    {/* Icon only - no label */}
                </button>
            </div>
        </div>
    );
}